export default __webpack_public_path__ + "static/fit-4255647f8abd4693a27024e03e7947a1.png";